import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { isIosDevice } from '@utils/deviceHelper';

export const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1.0';
export const IOS_APP_CHECKOUT_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1';

const isCheckoutPaymentPage = (asPath, subscriptionUID) =>
  Boolean(subscriptionUID) &&
  typeof asPath === 'string' &&
  asPath.includes('/subscribe/') &&
  !asPath.includes('thank-you');

const isIosAppSource = (source) => {
  if (typeof window === 'undefined') return false;
  return (
    (source === 'app' || localStorage.getItem('isAppSource') === 'true') &&
    isIosDevice()
  );
};

export const getIosAppCheckoutViewport = ({
  asPath,
  source,
  subscriptionUID
}) => {
  if (
    isCheckoutPaymentPage(asPath, subscriptionUID) &&
    isIosAppSource(source)
  ) {
    return IOS_APP_CHECKOUT_VIEWPORT;
  }
  return DEFAULT_VIEWPORT;
};

const applyViewportContent = (content) => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content', content);
  }
};

/**
 * Prevents iOS WKWebView from auto-zooming on <16px inputs and getting stuck
 * zoomed-in when pinch-zoom is disabled. Applies only on checkout payment && ios app source.
 */
const useIosAppCheckoutViewport = () => {
  const { asPath, query } = useRouter();
  const { source, subscriptionUID } = query;
  const [viewportContent, setViewportContent] = useState(DEFAULT_VIEWPORT);

  useEffect(() => {
    const nextContent = getIosAppCheckoutViewport({
      asPath,
      source,
      subscriptionUID
    });
    setViewportContent(nextContent);
    applyViewportContent(nextContent);

    return () => {
      applyViewportContent(DEFAULT_VIEWPORT);
    };
  }, [asPath, source, subscriptionUID]);

  return viewportContent;
};

export default useIosAppCheckoutViewport;
